import superagentPromise from 'superagent-promise';
import noCache from 'superagent-no-cache';

let superagent = require('superagent');
const _superagent = superagentPromise(superagent, global.Promise);

const agent = navigator.userAgent.toLowerCase();
let isIE = false;
if ((navigator.appName === 'Netscape' && agent.indexOf('trident') !== -1) || agent.indexOf('msie') !== -1) {
  isIE = true;
}

const finalNoCache = isIE ? noCache : req => {};

const errorState = res => {
  try {
    if (res.status === 400 || res.status === 401 || res.status === 404 || res.status === 500) {
      console.log('400 401 404 500 error');
    } else if (res.status === '403') {
      console.log('인증, 세션 오류');
    }
  } catch (err) {
    console.log(err);
  }
};

const responseBody = res => {
  errorState(res);
  return res.body;
};

// API 호출 error
const errorCatchCallback = (err, url) => {
  if (err.errno === 'ETIMEDOUT') {
    console.log('timeout');
  } else if (err.response.status !== 200) {
    // 조판 숨김/삭제 예외 처리 메세지
    errorState(err.response);
  }
  // else text = message(`error.${err.errno || err.errorCode}`) || err.errorMessage;
  // showMessagePopup({
  //     text
  // });
  // console.log('err', err.response);
  console.error(`${url} 호출 에러`, JSON.stringify(err));
  // throw err;
};

const retryCount = 0;

const requests = {
  del: url =>
    superagent
      .del(url)
      .withCredentials()
      .timeout({ response: 10000, deadline: 60000 })
      .retry(retryCount)
      .then(responseBody)
      .catch(err => errorCatchCallback(err, url)),
  get: (url, params, responseTimeout) =>
    superagent
      .get(url)
      .query(params)
      .withCredentials()
      .use(finalNoCache)
      .timeout({
        response: responseTimeout !== undefined ? responseTimeout : 15000,
        deadline: 60000,
      })
      .retry(retryCount)
      .then(responseBody)
      .catch(err => errorCatchCallback(err, url)),
  put: (url, body) =>
    superagent
      .put(url, body)
      .withCredentials()
      .timeout({ response: 10000, deadline: 60000 })
      .retry(retryCount)
      .then(responseBody)
      .catch(err => errorCatchCallback(err, url)),
  post: (url, body) =>
    superagent
      .post(url, body)
      .withCredentials()
      .timeout({ response: 10000, deadline: 60000 })
      .retry(retryCount)
      .then(responseBody)
      .catch(err => errorCatchCallback(err, url)),
  attach: (url, formData) => superagent.post(url, formData),
  postJSON: (url, body) =>
    superagent
      .post(url)
      .withCredentials()
      .set('Content-type', 'application/json')
      .send(body)
      .timeout({ response: 10000, deadline: 60000 })
      .retry(retryCount)
      .then(responseBody)
      .catch(err => errorCatchCallback(err, url)),
};

export default requests;
